export const english = {
	"language": "Language",
	"languages": "Languages",
	"status":"Status",
	"active":"Active",
	"disabled":"Disabled",
	"terminatedByUser":"Closed by Peer",
	"terminatedBySupported":"Closed by Supporter",
	"caseNumber":"Case N°",
	"questionNumber":"Question N°",
	"peerSupporter":"Peer Supporter",
	"requestDate":"Request Date",
	"caseDate":"Case Date",
	"caseStatus":"Case Status",
	"cases":"Cases",
	"description":"Description",
	"latestInteraction":"Latest Interaction",
	"assessment":"Interaction",
	"dashboard":"Dashboard",
	"activeCases":"Active Cases",
	"supportRequests":"Support Requests",
	"filters":"Filters",
	"casesByMonth":"Cases by Month",
	"reset":"Reset",
	"close":"Close",
	"managers":"Managers",
	"supporters":"Supporters",
	"myProfile":"My Profile",
	"logOut":"Log out",
	"pendingCases":"Pending Cases",
	"createNewCase":"Create new case",
	"total":"Total",
	"records":"records",
	"rows":"Rows",
	"newCase":"New Case",
	"caseDetails":"Case Details",
	"requested":"Requested",
	"select":"Select",
	"save":"Save",
	"cancel":"Cancel",
	"accept":"Accept",
	"ok":"Ok",
	"isRequired":"is required",
	"message":"Message",
	"assignTo":"Assign To",
	"basedOnLatestCaseAssessment":"Based on latest case assessment.",
	"loginAccess":"Mental Health Peer Support",
	"organization":"Organization",
	"email":"Email",
	"password":"Password",
	"signIn":"Sign In",
	"search":"Search",
	"notAvailableInfo":"Not available info",
	"firstName":"First Name",
	"lastName":"Last Name",
	"mobile":"Mobile",
	"supportRequestsMessage1":"No Requests",
	"supportRequestsMessage2":"Another Peer Supporter has already accepted this request",
	"endConversationMessage":"Are you sure you want to close this case?",
	"accountLockedMessage":"<strong class='color-error-dark'>Your account has been locked</strong> because you have reached the maximum number of invalid sign-in attempts. Please contact the administrator to recovery access.",
	"userPasswordLockedMessage":"<strong class='color-error-dark'>This user account has been locked</strong> due to multiple failed login attempts.<br />Click Reset Password button to unlock.",
	"deleteMessageHistory":"This Case has been closed, would you like to permanently delete this entire chat history?",
	"conversation":"Case",
	"psProfile":"Supporter Profile",
	"resetPasswordMobileMsg":"Your Password has been changed. You can now sign into your peer support mobile app",
	"linkExpiredMsg":"This link has already been used or expired",
}
